import { useLayoutEffect, useRef, useState } from "react";
import { metricTileValueBase, metricTileValueText } from "./metricTileStyles";

type MetricTileValueProps = {
  value: number;
  className?: string;
};

export function MetricTileValue({
  value,
  className = "text-white",
}: MetricTileValueProps) {
  const containerRef = useRef<HTMLDivElement>(null);
  const textRef = useRef<HTMLSpanElement>(null);
  const [fontSize, setFontSize] = useState<number | undefined>();

  useLayoutEffect(() => {
    const container = containerRef.current;
    const text = textRef.current;
    if (!container || !text) {
      return;
    }

    const fit = () => {
      text.style.fontSize = "";
      setFontSize(undefined);

      const maxSize = parseFloat(getComputedStyle(text).fontSize);
      const available = container.clientWidth;
      const needed = text.scrollWidth;

      if (needed > available && available > 0) {
        setFontSize(Math.max(maxSize * (available / needed) * 0.96, maxSize * 0.55));
      }
    };

    fit();
    const observer = new ResizeObserver(fit);
    observer.observe(container);
    return () => observer.disconnect();
  }, [value]);

  return (
    <div ref={containerRef} className={metricTileValueBase}>
      <span
        ref={textRef}
        className={`${metricTileValueText} ${className}`}
        style={fontSize ? { fontSize } : undefined}
      >
        {value.toLocaleString()}
      </span>
    </div>
  );
}
